import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import Spacer from 'Components/Spacer';
import { Typography } from 'Components/Typography';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

const BackgroundImage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 300px;
  padding: 30px;
  color: ${theme.colors.neutral[100]};
  background-size: cover;
  background: ${({ images }) => `no-repeat url(${images.mobile.src})`};
  text-align: center;
  background-position: center center;

  ${legacyTheme.breakpoints.up('md')} {
    background: ${({ images }) => `no-repeat url(${images.desktop.src})`};
  }
`;

const Container = styled.div`
  width: 100%;
  ${legacyTheme.breakpoints.up('md')} {
    padding: 0px 130px;
  }
`;

const StyledTitle = styled(Typography)`
  font-size: 16px;
`;

const TextOverBackgroundImage = ({ description, images, title }) => (
  <Container>
    <BackgroundImage images={images}>
      <StyledTitle bold variant="mono1">
        {title}
      </StyledTitle>
      <Spacer size={10} />
      <Typography variant="p1">{description}</Typography>
    </BackgroundImage>
  </Container>
);

TextOverBackgroundImage.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  images: PropTypes.shape({ mobile: srcOrNextImageProp, desktop: srcOrNextImageProp }).isRequired,
};

export default TextOverBackgroundImage;
